<template>
  <div class="row justify-center">
      <div class="card text-center px-1 py-2 m-auto" style="width:25rem;">
        <img class="card-img-top py-3 px-5" src="../assets/images/logo-aequaroma.jpg" alt="AEqua Roma" >
        <h6>Servizi per gli utenti del Patrimonio Immobiliare di Roma Capitale</h6>
        <h4>Registrazione utente</h4>
        <div class="d-flex flex-column card-body">
          <b-input v-model.trim="unitaImmobiliare" type="text" placeholder="Codice Unità immobiliare" class="m-1" :formatter="formatTrim" aria-required="true" :state="fieldUnitaImmobiliare"/>
          <!-- <b-form-invalid-feedback v-if="!$v.unitaImmobiliare.required">Campo obbligatorio</b-form-invalid-feedback> -->
          <b-input v-model.trim="codiceFiscale" type="text" placeholder="Codice Fiscale" class="m-1" :formatter="formatUcase" aria-required="true" :state="fieldCodiceFiscale" />
          <!-- <b-form-invalid-feedback v-if="!$v.codiceFiscale.required">Campo obbligatorio</b-form-invalid-feedback> -->
          <b-input v-model.trim="numeroMobile" type="text" placeholder="Numero Mobile (es 3331231234)" class="m-1" :formatter="formatTrim" aria-required="true" :state="fieldNumeroMobile" title=" Prefisso di tre cifre (3##), seguito dal numero telefonico (sei o sette cifre)"/>
          <!-- <b-form-invalid-feedback v-if="!$v.numeroMobile.required">Campo obbligatorio</b-form-invalid-feedback> -->
          <!-- <b-form-invalid-feedback v-if="!$v.numeroMobile.mobileValidate">Numero mobile non valido</b-form-invalid-feedback> -->

          <label class="text">Proseguendo nella registrazione dichiaro:</label>
          <div class="row my-1">
            <div class="col-auto" style="max-width:1.5rem;">
              <b-check class="form-check" v-model="seConsapevole"/>
            </div>
            <div class="col text-justify">
              di essere il soggetto identificato dal Codice Fiscale sopra riportato o persona da esso esplicitamente delegata a effettuare questa registrazione, ai sensi dell’art. 1387 del Codice Civile
            </div>
          </div>
          <div class="row my-1">
            <div class="col-auto" style="max-width:1.5rem;">
              <b-check class="form-check" v-model="seLetto"/>
            </div>
            <div class="col text-justify">
              di aver letto e compreso le condizioni di utilizzo e di accettarle integralmente
            </div>
          </div>
          <b-button variant="primary" size="lg" class="m-1" @click="onChangeClick">Registra</b-button>
          <b-button variant="outline-secondary" size="lg" class="m-1" @click="onCancelClick">Annulla</b-button>

        </div>
      </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

const codiceFiscale = (value, vm) => {
  var reCF = /[A-Za-z]{6}[0-9lmnpqrstuvLMNPQRSTUV]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9lmnpqrstuvLMNPQRSTUV]{2}[A-Za-z]{1}[0-9lmnpqrstuvLMNPQRSTUV]{3}[A-Za-z]{1}/
  var rePIVA = /[0-9]{11}/
  let retValue = false

  if (value.length === 16) {
    if (reCF.test(value)) {
      retValue = true
    }
  } else {
    if (rePIVA.test(value)) {
      retValue = true
    }
  }

  return retValue
}

const mobileValidate = (value, vm) => {
  // var re = /^([+]39)?((38[{8,9}|0])|(34[{7-9}|0])|(36[6|8|0])|(33[{3-9}|0])|(32[{8,9}]))([\d]{7})$/
  var re = /^((3[{1-9}][{0-9}]))([\d]{6,7})$/
  let retValue = false

  // console.log('value', value)
  // console.log('test value', re.test(value))
  if (re.test(value)) {
    retValue = true
  }

  return retValue
}

export default {

  data: () => {
    return {
      checking: true,
      base: false,
      unitaImmobiliare: '',
      numeroMobile: '',
      codiceFiscale: '',
      seConsapevole: false,
      seLetto: false
    }
  },
  validations: {
    unitaImmobiliare: { required },
    numeroMobile: { required, mobileValidate },
    codiceFiscale: { required, codiceFiscale },
    seConsapevole: { required (val) {
      return val
    } },
    seLetto: { required (val) {
      return val
    } }
  },

  computed: {
    fieldCodiceFiscale () {
      this.$v.codiceFiscale.$touch()

      return !this.$v.codiceFiscale.$invalid
    },
    fieldUnitaImmobiliare () {
      this.$v.unitaImmobiliare.$touch()

      return !this.$v.unitaImmobiliare.$invalid
    },
    fieldNumeroMobile () {
      this.$v.numeroMobile.$touch()

      return !this.$v.numeroMobile.$invalid
    }

  },
  methods: {
    onCancelClick () {
      this.$router.push({ name: 'home' })
    },
    validate () {
      this.$v.unitaImmobiliare.$touch()
      this.$v.numeroMobile.$touch()
      this.$v.codiceFiscale.$touch()
      this.$v.seConsapevole.$touch()
      this.$v.seLetto.$touch()

      return !this.$v.unitaImmobiliare.$invalid && !this.$v.numeroMobile.$invalid && !this.$v.codiceFiscale.$invalid && !this.$v.seConsapevole.$invalid && !this.$v.seLetto.$invalid
    },

    async onChangeClick () {
      try {
        if (this.validate()) {
          let paramData = {
            codiceFiscale: this.codiceFiscale.trim(),
            codiceImmobiliare: this.unitaImmobiliare.trim(),
            numeroCellulare: this.numeroMobile.trim(),
            seConsapevole: this.seConsapevole,
            seLetto: this.seLetto
          }

          await this.$store.dispatch('userRegistration', paramData)

          // Sul server deve essere eseguita la procedure "return stored.execute('aequa_register', null, data)"

          // console.log('seConsapevole', this.seConsapevole)
          // console.log('seLetto', this.seLetto)
          this.$ui.notify({
            type: 'info',
            title: 'Operazione completata',
            message: 'La registrazione è andata a buon fine.'
          })

          this.$router.push({ name: 'home' })
        } else {
          this.$ui.notify({
            type: 'warning',
            title: 'Dati non corretti',
            message: 'Verificare i dati inseriti.'
          })
        }
      } catch (err) {
        this.$ui.showError(err)
      }
    },
    formatUcase (value, event) {
      return value.toUpperCase().trim()
    },
    formatTrim (value, event) {
      return value.trim()
    },
    fieldState (field) {
      let v = this.$v.codiceFiscale
      return v.$dirty && v.$error ? false : null
    }

  }

}
</script>

<style lang="stylus" scoped>

</style>
